import { Subject } from 'rxjs';

const subject = new Subject();

export const designOrderService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};